var _path, _path2, _path3, _path4, _circle, _path5;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 100 100",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CACAD5",
    d: "M45.429 18.35c2.143-3.711 7.5-3.711 9.642 0l30.412 52.674c2.142 3.712-.536 8.35-4.822 8.35H19.84c-4.285 0-6.964-4.638-4.821-8.35z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B9BAB",
    d: "M47.283 25.306c1.319-2.284 4.615-2.284 5.934 0L78.53 69.152c1.319 2.284-.33 5.139-2.967 5.139H24.935c-2.637 0-4.285-2.855-2.966-5.139z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M52.854 66.914a2.604 2.604 0 1 1-5.207 0 2.604 2.604 0 0 1 5.207 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M50.126 34.89c1.183 0 2.141.958 2.141 2.14v21.08a2.141 2.141 0 0 1-4.282 0V37.03c0-1.182.959-2.14 2.141-2.14",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 69.5,
    r: 13.5,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#36CF8A",
    fillRule: "evenodd",
    d: "M31.645 62.26c-1-.728-2.4-.508-3.128.496l-7.162 9.862-3.856-3.91a2.239 2.239 0 1 0-3.19 3.144l5.711 5.791a2.24 2.24 0 0 0 3.407-.256l8.714-12c.727-1 .505-2.4-.496-3.127M39 85H23c-8.822 0-16-7.178-16-16s7.178-16 16-16c8.823 0 16 7.178 16 16z",
    clipRule: "evenodd"
  })));
});
const SvgWarningAmsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarningAmsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,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";